import React, { useEffect } from 'react'
import { CharLimitedInput } from '@/components/common/CharLimitedInput.jsx'
import { isEmpty } from 'lodash'
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group'
import { Label } from '@/components/ui/label'
import { Button } from '@/components/ui'
import { PlusIcon, TrashIcon } from '@/components/icons'

export function FormDescription(props) {
    const { description, descriptionValue, onChange, formErrors } = props

    const handleTypeChange = (type) => {
        onChange({
            descriptionType: type,
            list: type === 'list' ? [''] : undefined,
            paragraph: type === 'paragraph' ? '' : undefined,
        })
    }

    const updateListItem = (index, val) => {
        if (!descriptionValue.list) return
        const updated = [...descriptionValue.list]
        updated[index] = val
        onChange({ ...descriptionValue, list: updated })
    }

    const addListItem = () => {
        const updated = [...(descriptionValue.list || [])]
        updated.push('')
        onChange({ ...descriptionValue, list: updated })
    }

    const removeListItem = (index) => {
        if (!descriptionValue.list) return
        if (descriptionValue.list.length > 1) {
            const updated = descriptionValue.list.filter((_, i) => i !== index)
            onChange({ ...descriptionValue, list: updated })
        }
    }

    return (
        <div className="tw:flex tw:flex-col tw:gap-2">
            <div className="tw:text-white tw:text-sm tw:font-semibold">Description</div>
            <div className="flex gap-6 tw:relative">
                <RadioGroup
                    value={descriptionValue.descriptionType}
                    onValueChange={handleTypeChange}
                    className="tw:flex gap-4"
                >
                    <div className="tw:flex tw:items-center tw:gap-2">
                        <RadioGroupItem value="paragraph" id="paragraph" />
                        <Label htmlFor="paragraph" className="tw:text-white tw:text-sm tw:cursor-pointer">
                            Paragraph
                        </Label>
                    </div>
                    <div className="tw:flex tw:items-center tw:gap-2">
                        <RadioGroupItem value="list" id="list" />
                        <Label htmlFor="list" className="tw:text-white tw:text-sm tw:cursor-pointer">
                            List
                        </Label>
                    </div>
                </RadioGroup>
                {!isEmpty(formErrors['list[0]']) && descriptionValue.descriptionType === 'list' && (
                    <span className="tw:text-xs tw:text-red-500 tw:right-5 tw:top-3 tw:absolute">
                        {formErrors['list[0]']}
                    </span>
                )}
            </div>

            {descriptionValue.descriptionType === 'paragraph' && (
                <div className="tw:mt-2">
                    <CharLimitedInput
                        value={descriptionValue.paragraph || ''}
                        className={
                            !isEmpty(formErrors['paragraph']) && descriptionValue.descriptionType === 'paragraph'
                                ? 'tw:!border-red-500'
                                : ''
                        }
                        onChange={(val) => onChange({ ...descriptionValue, paragraph: val })}
                        placeholder="Include additional details"
                    />
                    {!isEmpty(formErrors['paragraph']) && descriptionValue.descriptionType === 'paragraph' && (
                        <div className="tw:text-xs tw:text-red-500 tw:pl-1 tw:pt-1 tw:absolute">
                            {formErrors['paragraph']}
                        </div>
                    )}
                </div>
            )}

            {descriptionValue.descriptionType === 'list' && (
                <div className="tw:flex tw:flex-col tw:gap-4 tw:mt-2">
                    {(descriptionValue.list || []).map((item, i) => (
                        <div key={i} className="tw:flex items-center gap-2 w-100">
                            <CharLimitedInput
                                value={item}
                                onChange={(val) => updateListItem(i, val)}
                                className={
                                    !isEmpty(formErrors['list[0]']) && descriptionValue.descriptionType === 'list'
                                        ? 'tw:!border-red-500'
                                        : ''
                                }
                                placeholder={`List item ${i + 1}`}
                            />
                            {i !== 0 && (
                                <Button
                                    type="button"
                                    variant="link"
                                    className="tw:has-[>svg]:px-0 tw:px-0"
                                    onClick={() => removeListItem(i)}
                                >
                                    <TrashIcon className="tw:w-6 tw:h-6 tw:text-blue-400" />
                                </Button>
                            )}
                        </div>
                    ))}

                    <Button variant="secondary" className="tw:!px-2 tw:w-[114px]" type="button" onClick={addListItem}>
                        <PlusIcon className="tw:h-6 tw:w-6" />
                        <span>Add Item</span>
                    </Button>
                </div>
            )}
        </div>
    )
}
